import api from '@/utils/api'

export default {
    getMaterials(page, size, query, sort) {
        let filter = null
        Object.keys(query).forEach(key => {
            if (!query[key]) {
                delete query[key]
            }
        })
        if (Object.keys(query).length > 0) {
            filter = query
        }
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`materials` + (page ? range : '') + (filter ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '') + (sort ? `&sort=${encodeURIComponent(sort)}` : ''))
    },

    getMaterial(id, contractorId) {
        return api.get(contractorId > 0 ? `materials/${id}?contractorId=${contractorId}` : `materials/${id}`)
    },

    changeMaterialQuantity(id, contractorId, data) {
        return api.post(contractorId > 0 ? `materials/change-quantity/${id}?contractorId=${contractorId}` : `materials/change-quantity/${id}`, data)
    },

    createMaterial(data) {
        return api.post('materials', data)
    },

    updateMaterial(id, data) {
        return api.put(`materials/${id}`, data)
    },

    getAvailableMaterials(contractorId, tab) {
        return api.get(`materials/available?contractorId=${contractorId}&tab=${tab}`)
    },
    exportMaterials(clientId) {
        return api.get(clientId ? `materials/export?clientId=${clientId}` : `materials/export`)
    },
    exportUsedMaterials(clientId) {
        return api.get(clientId ? `materials/used/export?clientId=${clientId}` : `materials/used/export`)
    },
    import(clientId, tab, formData) {
        let url = `materials/import`
        const params = new URLSearchParams()

        if (clientId) {
            params.append('clientId', clientId)
        }
        if (tab) {
            params.append('tab', tab)
        }
        const query = params.toString()
        if (query) url += `?${query}`
        return api.uploadFile(url, formData)
    }
}
